import { useMemo } from 'react';

import { ToplineResult } from '@customTypes/order';

interface IProps {
  summary: ToplineResult[];
}

export function hasApoeSummary(summary: ToplineResult[] | undefined): boolean {
  return (summary ?? []).some(item => Boolean(item.details || item.text));
}

export function ApoeSummaryPane({ summary }: IProps) {
  const finding = summary[0]?.finding?.toLowerCase() ?? '';
  const paragraphs = useMemo(() => summary.map(item => item.details || item.text).filter(Boolean), [summary]);

  return (
    <div className='summary-pane result-details-tab-content'>
      <div className={`summarize ${finding}`}>
        {paragraphs.map((item, index) => (
          <p key={index}>{item}</p>
        ))}
      </div>
    </div>
  );
}
